import { useState, useCallback } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";

export interface RefreshTokenResponse {
  access: string;
}

export const useRefreshToken = () => {
  const [data, setData] = useState<RefreshTokenResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const refreshAccessToken = useCallback(async () => {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      setError("Refresh token is missing.");
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.post<RefreshTokenResponse>(
        "users/api/token/refresh/",
        { refresh: refreshToken },
      );

      const newAccessToken = response.data.access;
      setData(response.data);

      localStorage.setItem("authToken", newAccessToken);
      localStorage.setItem("refreshToken", refreshToken);

      return newAccessToken;
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, error, refreshAccessToken };
};
